module.exports = __webpack_public_path__ + "static/media/hand-holding-usd.1f2b0c74.svg";